import Cookies from 'js-cookie'

const SystemId = 'System-Id'
const SystemName = 'System-Name'
const domain = document.domain

export function setSystemId(systemId) {
  localStorage.setItem(domain + SystemId, systemId)
  return Cookies.set(SystemId, systemId)
}

export function getSystemId() {
  return Cookies.get(SystemId) || localStorage.getItem(domain + SystemId)
}

export function removeSystemId() {
  localStorage.removeItem(domain + SystemId)
  return Cookies.remove(SystemId)
}

export function setSystemName(systemName) {
  localStorage.setItem(domain + SystemName, systemName)
  return Cookies.set(SystemName, systemName)
}

export function getSystemName() {
  return Cookies.get(SystemName) || localStorage.getItem(domain + SystemName)
}

export function removeSystemName() {
  localStorage.removeItem(domain + SystemName)
  return Cookies.remove(SystemName)
}



// WEBPACK FOOTER //
// ./src/utils/systemInfo.js